import { render, staticRenderFns } from "./Efficiency.vue?vue&type=template&id=d938e344&scoped=true"
import script from "./Efficiency.vue?vue&type=script&lang=js"
export * from "./Efficiency.vue?vue&type=script&lang=js"
import style0 from "./Efficiency.vue?vue&type=style&index=0&id=d938e344&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d938e344",
  null
  
)

export default component.exports